import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaPlaceholder'

type IcaPlaceholderProps = React.JSX.IntrinsicElements['tgdb-ica-placeholder']

export const IcaPlaceholder = wrapWc<IcaPlaceholderProps>('tgdb-ica-placeholder', [])